import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import SectionContact from '../components/SectionContact';
import err404 from '../imgs/404.svg'

export default function PageNotFound() {
	return (
		<>
			<Helmet>
				<title>Pagina non trovata &bull; Travolgi &bull; Sii unico, sii travolgente!</title>
			</Helmet>

			<section className="container grid g-2">
				<img src={err404} alt="404 Page Not Found • Travolgi" />

				<div>
					<h1>404 Error</h1>
					<h2 className="mb-0">Pagina non trovata</h2>
					<p className="mb-3">OPS! Non siamo riusciti a trovare ciò che stavi cercando.</p>
					<Link to="/" className="btn">Torna all'Home</Link>
				</div>
			</section>

			<SectionContact />
		</>
	);
}